<template>
  <section class="introduce_page">
    <NavBar />
    <Header type="personalCenter" />
    <div class="content box p300">
      <div v-html="text"></div>
    </div>
  </section>
</template>

<script>
  import NavBar from 'components/NavBar/index.vue';
  import Header from 'components/Header/index.vue';
  import {
    getData
  } from 'api/serviceAgreement.js';

  export default {
    components: {
      NavBar,
      Header
    },

    created() {
      this.getData();
    },

    data() {
      return {
        text: ''
      }
    },

    methods: {
      getData() {
        getData({
          agreeType: 24
        }).then(res => {
          if(res.code) {
            this.$message.error(res.message);
            return;
          }
          this.text = res.data;
        });
      }
    }
  }
</script>

<style lang="less" scoped>
  .introduce_page {
    .content {

    }
  }
</style>
